<template>
    <template v-if="!isMachinePage">
    <Header></Header>
    <main>
        <BreadCrumbs></BreadCrumbs>

        <FiltersWrapper @update="dialogs.filterDialog = true">
            <template #clear><ClearAllButton v-if="hasFilters" @click="clearAll"></ClearAllButton></template>
            <template #search><Search :key="searchKey" @search="onSearch" @update:modelValue="onSearch"></Search></template>
            <template #sort><SortBy :key="searchKey" v-model="filters.sort" :sort="sortOptions"></SortBy></template>
        </FiltersWrapper>
        <ProductWrapper>
            <template #category>
                <UgmFilters
                    :class="{ 'show': dialogs.filterDialog }"
                    :filters="filters"
                    :categories="facets.categories"
                    :makes="facets.makes"
                    @update="dialogs.filterDialog = false"
                ></UgmFilters>
            </template>
            <template #product>
                <div class="status" v-if="data_info.error">The catalogue is temporarily unavailable. Please try again later.</div>
                <div class="status" v-else-if="!data_info.loading && arr_data.length === 0">No machines found. Try changing the filters.</div>
                <template v-else>
                    <div class="total" v-if="data_info.total">{{ data_info.total }} machines</div>
                    <UgmMachineList :class="{ 'loading': data_info.loading }" :itemsPerRow="3" :products="arr_data"></UgmMachineList>
                </template>
            </template>
            <template #list-flip>
                <ListFlip
                    v-if="data_info.totalPages > 1"
                    v-model:totalPages="data_info.totalPages"
                    v-model:currentPage="data_info.page"
                ></ListFlip>
            </template>
        </ProductWrapper>
        <FaqBlock style="padding-bottom: 120px;"></FaqBlock>
    </main>
    <Footer></Footer>
    </template>
    <router-view v-else />
</template>

<script>
import Header from "@/components/Header/Header.vue";
import Footer from "@/components/Footer/Footer.vue";
import BreadCrumbs from "@/components/UI/BreadCrumbs.vue";
import FiltersWrapper from "@/components/Products/FiltersWrapper.vue";
import ClearAllButton from "@/components/Products/ClearAllButton.vue";
import Search from "@/components/UI/Search.vue";
import SortBy from "@/components/UI/SortBy.vue";
import ProductWrapper from "@/components/Products/ProductWrapper.vue";
import ListFlip from "@/components/Products/ListFlip.vue";
import FaqBlock from "@/components/Templates/FaqBlock.vue";
import UgmFilters from "@/components/Ugm/UgmFilters.vue";
import UgmMachineList from "@/components/Ugm/UgmMachineList.vue";
import axios from "axios";

const defaultFilters = () => ({
    search: '',
    sort: 'latest',
    category: { open: true, value: [] },
    make: { open: false, value: [] },
});

export default {
    components: {
        Header,
        Footer,
        BreadCrumbs,
        FiltersWrapper,
        ClearAllButton,
        Search,
        SortBy,
        ProductWrapper,
        ListFlip,
        FaqBlock,
        UgmFilters,
        UgmMachineList,
    },
    data() {
        return {
            arr_data: [],
            facets: { categories: [], makes: [] },
            filters: defaultFilters(),
            sortOptions: [
                { id: 'latest', title: 'Latest' },
                { id: 'oldest', title: 'Oldest' },
                { id: 'year', title: 'Year of make' },
                { id: 'title', title: 'Name A–Z' },
            ],
            data_info: {
                loading: true,
                error: false,
                page: 1,
                totalPages: 1,
                total: 0,
            },
            dialogs: {
                filterDialog: false,
            },
            searchKey: 0,
            searchTimer: null,
            requestId: 0,
        }
    },
    computed: {
        isMachinePage() {
            return !!this.$route.params.slug;
        },
        hasFilters() {
            return this.filters.search !== '' || this.filters.category.value.length > 0 || this.filters.make.value.length > 0;
        },
    },
    methods: {
        getData() {
            const requestId = ++this.requestId;
            this.data_info.loading = true;
            axios.get('/ugm/machines', {
                params: {
                    page: this.data_info.page,
                    search: this.filters.search || undefined,
                    sort: this.filters.sort,
                    category: this.filters.category.value,
                    make: this.filters.make.value,
                },
            }).then(resp => {
                // Игнорируем устаревшие ответы, если пользователь уже сменил фильтры
                if (requestId !== this.requestId || !resp.data.result) return;
                this.arr_data = resp.data.data;
                this.facets = resp.data.filters;
                this.data_info.total = resp.data.total;
                this.data_info.totalPages = resp.data.total_pages;
                this.data_info.page = resp.data.current_page;
                this.data_info.error = false;
            }).catch(() => {
                if (requestId === this.requestId) this.data_info.error = true;
            }).finally(() => {
                if (requestId === this.requestId) this.data_info.loading = false;
            });
        },
        reload() {
            if (this.data_info.page !== 1) {
                this.data_info.page = 1; // watcher сам перезапросит
            } else {
                this.getData();
            }
        },
        onSearch(value) {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.filters.search = (value || '').trim();
            }, 400);
        },
        clearAll() {
            this.filters = defaultFilters();
            this.searchKey++; // сбрасываем поле поиска и сортировку
        },
    },
    mounted() {
        this.getData();
    },
    beforeUnmount() {
        clearTimeout(this.searchTimer);
    },
    watch: {
        'filters.search'() { this.reload(); },
        'filters.sort'() { this.reload(); },
        'filters.category.value'() { this.reload(); },
        'filters.make.value'() { this.reload(); },
        'data_info.page'() {
            this.getData();
            window.scrollTo({ top: 90, behavior: 'smooth' });
        },
        isMachinePage(value) {
            // вернулись из карточки машины на список
            if (!value) this.getData();
        },
    },
}
</script>

<style scoped>
.status{
    padding: 80px 0;
    text-align: center;
    color: rgb(85, 98, 114);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
}
.total{
    color: rgb(85, 98, 114);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    padding-bottom: 16px;
}
.loading{
    opacity: 0.5;
    transition: opacity 0.2s;
}
</style>
